import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import {
    getLandingPageTemplates,
    getLeadCustomSources,
    postCreateLandingPage,
} from "../../../../redux/slices/landingPages/landingPages.asyncActions";
import {
    getPublishLandingPage,
    putUpdateLandingPage,
} from "../../../../redux/slices/landingPages/landingPages.asyncActions";
import {
    getGamificationTemplates,
    getGenerateCode,
} from "../../../../redux/slices/landingPages/landingPages.asyncActions";
import { clearState } from "../../../../redux/slices/landingPages/landingPages.slice";
import AddEditLandingPage from "./AddEditLandingPage.layout";
import { AddEditLandingPageStateProps } from "./AddEditLandingPage.types";

const mapStateToProps = (state: any): AddEditLandingPageStateProps => ({
    language: state.languagesState.languages,
    landingPageForm: state.landingPages.landingPageForm,
    landingPageFormStep: state.landingPages.landingPageFormStep,
    landingPageDetails: state.landingPages.landingPageDetails,
    customSources: state.landingPages.customSources,

    appDetails: state.landingPages.appDetails,
    code: state.landingPages.code,
    isLandingPageCreated: state.landingPages.isLandingPageCreated,
    isLandingPageFormLoading: state.landingPages.isLandingPageFormLoading,
    templates: state.landingPages.templates,
    gamificationTemplates: state.landingPages.gamificationTemplates,
    lastAddedDraftLandingPage: state.landingPages.lastAddedDraftLandingPage,
});

const mapDispatchToProps = (dispatch: any): any => ({
    dispatchGetTemplates: () => dispatch(getLandingPageTemplates()),
    dispatchClearState: (payload: any) => dispatch(clearState(payload)),
    dispatchGenerateCode: () => dispatch(getGenerateCode()),
    dispatchPreviewLandingPage: (payload: any) =>
        dispatch(postCreateLandingPage(payload)),
    dispatchPublishLandingPage: (payload: any) =>
        dispatch(getPublishLandingPage(payload)),
    dispatchPutUpdateLandingPage: (payload: any) =>
        dispatch(putUpdateLandingPage(payload)),
    dispatchGetGamificationTemplates: () =>
        dispatch(getGamificationTemplates()),
    dispatchLeadCustomSources: () => dispatch(getLeadCustomSources()),
});

const decorate = compose(connect(mapStateToProps, mapDispatchToProps));

export default decorate(AddEditLandingPage);
